// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"78814061","25":"f608eb56","238":"844bb768","412":"0bfea715","472":"de93346d","496":"859c67f7","526":"84cc5bcb","678":"e4526a6a","856":"59ecd243"}[chunkId] + ".chunk.js";
};